import { requestFetch, number_format } from '@/js/helpers';

const getCount = async () => {
    const path = `/api/property/count`
    const resp = await requestFetch(path);
    return resp.data;
}
const main = () => {
    if (document.querySelector('.c-others-home-search') === null) return;

    const baseDomList = document.querySelectorAll('.c-others-home-search');
    getCount().then(data => {
        baseDomList.forEach(baseDom => {
            baseDom.querySelector('.js-count-total').textContent = number_format(data.all);
            baseDom.querySelector('.js-count-new').textContent = number_format(data.new);
            baseDom.querySelector('.js-count-tour').textContent = number_format(data.tour);
        })
    })
}

export default main;
